// extracted by mini-css-extract-plugin
export default {"lastRetrieveTimestamp":"style_lastRetrieveTimestamp__+HkN2"};